import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { PatientsService } from "../patient-service/patients.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { take } from "rxjs/operators";
import { MessageService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { validate } from "json-schema";

@Component({
  selector: "app-patients-register",
  templateUrl: "./patients-register.component.html",
  styleUrls: ["./patients-register.component.css"],
  providers: [MessageService]
})
export class PatientsRegisterComponent implements OnInit {
  ptForm: FormGroup;
  token: any;
  id: any;
  isUpdate = false;
  patData: {
    _id: string;
    isDeleted: boolean;
    isEnabled: boolean;
    name: string;
    // email: string;
    regBy: string;
    phoneNo: number;
    userType: string;
    chargeable: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };

  constructor(
    private patientsService: PatientsService,
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.queryParams["id"];
    if (this.id) {
      this.isUpdate = true;
    }
    this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
      this.token = res._token;
    });
    if (this.isUpdate) {
      this.getSinglePatient();
    }
    if (!this.ptForm) {
      this.oninitForm();
    }
  }
  oninitForm() {
    var name = this.patData ? this.patData.name : null;
    // const email = this.patData ? this.patData.email : null;
    var phoneNo = this.patData ? this.patData.phoneNo : null;
    var userType = this.patData ? this.patData.userType : null;
    var chargeable = this.patData ? this.patData.chargeable : null;

    this.ptForm = new FormGroup({
      name: new FormControl(name, Validators.required),
      // email: new FormControl(email, [Validators.required, Validators.email]),
      // password: new FormControl(null, Validators.required),
      userType: new FormControl(userType, Validators.required),
      chargeable: new FormControl(chargeable, Validators.required),

      phoneNo: new FormControl(phoneNo, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.minLength(10)
      ])
    });
  }
  onSubmit() {
    var name = this.ptForm.value["name"];
    var phoneNo = this.ptForm.value["phoneNo"];
    var userType = this.ptForm.value["userType"];
    var chargeable = this.ptForm.value["chargeable"];
    console.log("CHARGEABLE", chargeable);
    if (this.isUpdate) {
      this.patientsService
        .updatePatientsToDb(
          name,
          phoneNo,
          userType,
          chargeable,
          this.token,
          this.id
        )
        .subscribe(
          res => {
            this.router.navigate(["../"], {
              relativeTo: this.activatedRoute
            });
          },
          err => {
            this.messageService.add({
              key: "tc",
              severity: "success",
              summary: "Update Failed",
              detail: "check your internet connection"
            });
          }
        );
    } else {
      this.patientsService
        .savePatientsToDb(
          name,
          // email,
          // password,
          phoneNo,
          userType,
          chargeable,
          this.token
        )
        .subscribe(
          res => {
            this.router.navigate(["../"], {
              relativeTo: this.activatedRoute
            });
          },
          err => {
            this.messageService.add({
              key: "tc",
              severity: "success",
              summary: "Registration Failed",
              detail: "check your internet connection"
            });
          }
        );
    }
  }

  getSinglePatient() {
    this.patientsService
      .getSinglePatient(this.id, this.token)
      .subscribe(res => {
        this.patData = res.data;
        this.oninitForm();
        console.log(res);
      });
  }
}
